/**
 * 线索流转记录
 * @author v_linhairao
 */
import React, { FunctionComponent, useMemo } from 'react'
import { Card, Table } from 'antd'
import { TableProps } from 'antd/lib/table'
import { CommonFilters, PageHeader, UserAvatar } from '@components'
import { TableColumnProps, useTableColumn } from '@hooks'
import { CirculateRecordFilter, CirculateRecordItem, needTotalEnum, sortTypeEnum } from '@types'
import { changeTypeMap } from '@configs/map'
import { getLeadCirculateRecordList } from '@services/lead'
import { getSortOrder, getTableXwidth, TableIdEnum } from '@configs/table'
import { ConfigTableHeader } from '../../../components/ConfigTableHeader'
import moment from 'moment'
import { formatTime } from '@library'
import { circulateRecordFilterItems } from '../../../components/CommonFilters/configs'
import { useTableService } from '@hooks/useTableService'

const initFilterValue = { createTime: [moment().subtract(1, 'month'), moment()] }
const initFilter: CirculateRecordFilter = {
  page: 1,
  pageSize: 10,
  needTotal: needTotalEnum.LIST,
  sort: 'createTime',
  createTimeFrom: formatTime(initFilterValue.createTime[0], 'start'),
  createTimeTo: formatTime(initFilterValue.createTime[1], 'end'),
  sortType: sortTypeEnum.DESC,
}

const LeadCirculateRecordPage: FunctionComponent = () => {
  const {
    loading,
    list,
    pagination,
    filter,
    setFilter,
    resetFilter,
    rowKey,
  } = useTableService(getLeadCirculateRecordList, initFilter, '获取线索流转记录失败')

  const onTableChange: TableProps<CirculateRecordItem>['onChange'] = (pagination, filters, sorter) => {
    const sort = getSortOrder<CirculateRecordFilter>(sorter)
    setFilter(sort)
  }

  const columns: TableColumnProps<CirculateRecordItem>[] = useMemo(() => [
    { title: '线索id', dataIndex: 'leadId', width: 120 },
    { title: '线索名称', dataIndex: 'leadName', width: 200 },
    { title: 'UIN', dataIndex: 'uin', width: 150 },
    { title: '变更类型', dataIndex: 'changeType', render: changeType => changeTypeMap[changeType] || '', width: 220 },
    { title: '变更后跟进人', dataIndex: 'afterFollowerNameEn', width: 220, render: value => <UserAvatar salesName={value} /> },
    { title: '变更后所属组', dataIndex: 'afterFollowerGroupName', width: 220 },
    { title: '变更原因', dataIndex: 'remark', width: 200 },
    { title: '操作人', dataIndex: 'operator', width: 220, render: value => <UserAvatar salesName={value} /> },
    {
      title: '变更时间',
      dataIndex: 'createTime',
      width: 180,
      sorter: true,
      defaultSortOrder: 'descend',
      sortDirections: ['descend', 'ascend'],
    },
  ], [filter])
  const [columnConfigs, columnProps, forceRequest] = useTableColumn(TableIdEnum.LEAD_CIRCULATE, columns, ['leadId'])
  const tableXWidth = useMemo(() => getTableXwidth(columnProps), [columnProps])

  /* 列表选择相关 */
  return (
    <>
      <PageHeader title="线索流转记录" />
      <Card className="mt20 mb20">
        <CommonFilters
          className="custom-Label"
          initValue={initFilterValue}
          itemList={circulateRecordFilterItems}
          onSubmit={filter => setFilter({ ...filter, page: 1 })}
          onReset={() => resetFilter(initFilter)}
        />
      </Card>
      <Card>
        <ConfigTableHeader columnConfigs={columnConfigs} tableId={TableIdEnum.LEAD_CIRCULATE} onSuccess={() => forceRequest()} />
        {/* <TableDownload className="ml20" exportMethod={exportCustomerChangeRecordList} filter={filter} /> */} {/** 下载接口未开发 */}
        <Table
          tableLayout="fixed"
          className="mt20"
          loading={loading}
          pagination={pagination}
          scroll={{ x: tableXWidth }}
          rowKey={rowKey}
          dataSource={list}
          columns={columnProps}
          onChange={onTableChange}
        />
      </Card>
    </>
  )
}
export default LeadCirculateRecordPage
